<span [ngClass]="{ 'editable': editable }" *ngIf="!editing" (click)="startEditing()">{{ text }}</span>
<input type="text" #textInput *ngIf="editing" [formControl]="inputControl" (blur)="finishEditing()" (keydown.enter)="finishEditing()" (keydown.escape)="cancelEditing()" [size]="inputFieldSize" />
